import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";
toast.configure();
/**
 * @description method call for create location
 * @param {Object} data accepting form json object
 * @param {Function} callback callback function get revorts
 * @returns object response 
 */
export const add = (data, callback) => {

    return (dispatch,getState) => {
        dispatch({ type: "ISLOADING", data: true });
        const { user: { token } } = getState();
    ApiClient.postFormData(`${apiUrl}${PORT}/location`, data,token, dispatch).then((response) => {
            dispatch({ type: "ISLOADING", data: false });
            if (response.errors) {
              if (response.errors.msg === 'NAME_ALREADY_EXISTS') 
                  toast.error('Work group name already exists', toasterConfig);
              else
              toast.error(response.errors.msg, toasterConfig);
              return callback();
          } else if (response) {
              toast.dismiss();
              toast.success("Work group has been added successfully", toasterConfig);
              return callback(response);
          } else {
              toast.error(response.message);
              return callback();
          }
        });
    };
};

/**
 * @description function use for to get location
 * @param {*} params accepting object
 */
export const getItems = (params, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: "ISLOADING" });
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/location`, params, token)
            .then((response) => {
                dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response);
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false);
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false);
                }
            })
            .catch((e) => console.log(e, "error"));
    };
};

/**
 * @description function use for to get location
 * @param {*} params accepting object
 */
export const getItem = (id,callback) => {
    return (dispatch, getState) => {
        dispatch({ type: "ISLOADING" });
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/location/${id}`, {}, token)
            .then((response) => {
                dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response);
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false);
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false);
                }
            })
            .catch((e) => console.log(e, "error"));
    };
};

/**
 * @description function use for to update location
 * @param {*} params accepting object
 */
export const update = (data, id, callback) => {
    return (dispatch, getState) => {
        const {
          user: { token },
        } = getState();
        ApiClient.putFormData(`${apiUrl}${PORT}/location/${id}`, data,token,dispatch).then(
          (response) => {
            if (response.errors) {
              if (response.errors.msg === 'NAME_ALREADY_EXISTS')
                toast.error('Work group name already exists', toasterConfig);
              else
                toast.error(response.errors.msg, toasterConfig);
              return callback();
            } else if (response) {
              toast.dismiss();
              toast.success("Work Group has been updated successfully", toasterConfig);
              return callback(response);
            } else {
              toast.error(response.message);
              return callback();
            }
          }
        );
      };
};


